import { DVIInspectionFull } from '../../types/dvi';
import { isItemSatisfied } from './DVIInspectionForm';

export interface InspectionCounts { pass: number; attention: number; fail: number }

export type InspectionState =
  | { kind: 'none' }
  | { kind: 'in_progress'; done: number; total: number; counts: InspectionCounts }
  | { kind: 'complete'; worst: 'pass' | 'attention' | 'fail'; counts: InspectionCounts };

/**
 * Collapse a DVIInspectionFull (or its absence) into the three display states
 * used by the read-only views. "done" counts items satisfied per point_type
 * (status → non-pending, reading → non-blank value, photo → ≥1 photo) — the
 * same isItemSatisfied logic the editor and backend completion gate use.
 */
export function getInspectionState(inspection?: DVIInspectionFull | null): InspectionState {
  if (!inspection) return { kind: 'none' };
  const counts = inspection.items.reduce<InspectionCounts>(
    (acc, i) => {
      if (i.status === 'pass') acc.pass++;
      else if (i.status === 'attention') acc.attention++;
      else if (i.status === 'fail') acc.fail++;
      return acc;
    },
    { pass: 0, attention: 0, fail: 0 },
  );
  if (inspection.status === 'completed') {
    const worst = counts.fail > 0 ? 'fail' : counts.attention > 0 ? 'attention' : 'pass';
    return { kind: 'complete', worst, counts };
  }
  return {
    kind: 'in_progress',
    done: inspection.items.filter(isItemSatisfied).length,
    total: inspection.items.length,
    counts,
  };
}
